enum ContentType {
  JSON = 'application/json',
  MULTIPART = 'multipart/form-data',
  FORM = 'application/x-www-form-urlencoded',
}

export default ContentType;


// WEBPACK FOOTER //
// ./src/dataModel/HttpContentType.ts